import React from "react";
import { formatDate } from "../../../helper/Helper";
import { Link } from "react-router-dom";

const CouponRow = React.memo(
  ({
    coupon,
    index,
    page,
    limit,
    onStatusChange,
    onVisibilityChange,
    onDelete,
  }) => {
    const isActive = coupon.status === "active";
    const isVisible = coupon.isVisible !== false;

    return (
      <tr>
        <td>{(page - 1) * limit + index + 1}.</td>

        <td>{coupon.title}</td>
        <td>
          <span className="">
            <code className="badge bg-outline-secondary badge-md text-secondary">
              <b>{coupon.code}</b>
            </code>
          </span>
        </td>
        <td>
          {coupon.discountType === "PERCENTAGE"
            ? `${coupon.discountValue}%`
            : `₹${coupon.discountValue}`}
        </td> 
        <td>
          <span className={`badge ${isVisible ? "bg-success" : "bg-danger"}`}>
            {isVisible ? "Visible" : "Hidden"}
          </span>
        </td>
        <td>{formatDate(coupon.startDate, "D MMM YYYY")}</td>
        <td>{formatDate(coupon.endDate, "D MMM YYYY")}</td>
        <td className="action-table-data">
          <div className="edit-delete-action">
            <button
              className={`btn btn-sm me-2 ${
                isVisible ? "btn-danger" : "btn-primary"
              }`}
              onClick={() => onVisibilityChange(coupon._id, !isVisible)}
            >
              {isVisible ? "Hide" : "Unhide"}
            </button>

            <button
              className={`btn btn-sm me-2 ${
                isActive ? "btn-danger" : "btn-primary"
              }`}
              onClick={() =>
                onStatusChange(coupon._id, isActive ? "deactive" : "active")
              }
            >
              {isActive ? "Deactivate" : "Activate"}
            </button>

            <Link
              to={`/coupon/edit/${coupon._id}`}
              className="me-2 p-2"
              state={{ id: coupon._id }}
            >
              <i className="ti ti-pencil" />
            </Link>

            <a
              className="p-2"
              href="javascript:void(0);"
              data-bs-toggle="modal"
              data-bs-target="#delete-modal"
              onClick={(e) => {
                onDelete(coupon._id);
              }}
            >
              <i className="ti ti-trash" />
            </a>
          </div>
        </td>
      </tr>
    );
  },
);

export default CouponRow;
